import { useReducer, useEffect, useState } from "react";
import instance from "../../Interceptor/api_instance";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../Auth/AuthProvider";
import { VehicleTabs } from "../../Components/Tables/Vehicles/Tabs";
import { useTransformData } from "../../Hooks/useTransformData";
import { PageLayout } from "../../Components/PageLayout";
import OverviewGraphics from "../../Components/Graphics/OverviewGraphics";
import TrailersInventory from "./InventoryTables/Trailers";
import TrucksInventory from "./InventoryTables/Trucks";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_DATA":
      return { ...state, isFetchingData: true };
    case "STORE_DATA":
      return { ...state, data: action.data, isFetchingData: false };
    case "SET_SELECTED_ROW":
      return {
        ...state,
        selectedRow: action.selectedRow,
      };
    case "CLOSE_SELECTED_ROW":
      return {
        ...state,
        selectedRow: null,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

const initialState = {
  data: [],
  isFetchingData: true,
  selectedRow: null,
  error: null,
};

export const OverviewRefactor = ({}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const tabs = ["Trailers", "Trucks"];
  const [selectedTab, setSelectedTab] = useState("Trailers");

  const [truckState, truckDispatch] = useReducer(reducer, {
    ...initialState,
    url: "assets/view-trucks?q=200",
  });

  const { TransformEventData } = useTransformData();

  const fetchData = async (state, dispatch, type) => {
    try {
      dispatch({ type: "FETCH_DATA" });
      const response = await instance.get(state.url);
      dispatch({
        type: "STORE_DATA",
        data:
          type === "trailer"
            ? TransformEventData(response.data)
            : TransformEventData(response.data),
      });
    } catch (error) {
      dispatch({ type: "SET_ERROR", error: error });
    }
  };

  useEffect(() => {
    fetchData(truckState, truckDispatch, "truck");
  }, []);

  return (
    <PageLayout title={"Overview"}>
      <div className="overview-header">
        <h1 className="global-h1 black">{t("page-headers.overview")}</h1>
        <h4 className="global-h4 gray">
          {t("page-subheaders.welcome")}, {user.first_name}
        </h4>
      </div>
      <OverviewGraphics truckState={truckState} />
      <div className="inventory-header">
        <h2 className="light-black global-h2">{t("page-headers.inventory")}</h2>
      </div>
      <VehicleTabs
        tabs={tabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      {selectedTab === "Trailers" && (
        <TrailersInventory />
      )}
      {selectedTab === "Trucks" && (
        <TrucksInventory />
      )}
    </PageLayout>
  );
};
